import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Card, CardMedia, CardContent, Typography, CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import CameraScreen from './CameraScreen';
import { apiService } from '../services/apiService';
import InspeccionData from '../models/InspeccionData';
import Frente from '../assets/img/frente.png';
import Lateral_Derecho from '../assets/img/lateral_derecho.png';
import Lateral_Izquierdo from '../assets/img/lateral_izquierdo.png';
import Trasera from '../assets/img/trasera.png';
import Frente_de_Cedula_Verde from '../assets/img/cedula.png';
import Parabrisas_desde_Interior from '../assets/img/parabrisas.png';
import Rueda_de_Auxilio from '../assets/img/rueda.png';
import Frente_de_Tarjeta_GNC from '../assets/img/1.png';
import Dorso_de_Tarjeta_GNC from '../assets/img/2.png';
import Nro_de_Chasis from '../assets/img/chasis_m.png';
import Certificado_de_No_rodamiento from '../assets/img/certificado.png';
import Frente_ from '../assets/img/frente_m.png';
import Lateral_Derecho_ from '../assets/img/derecho_m.png';
import Lateral_Izquierdo_ from '../assets/img/izquierdo_m.png';
import Trasera_ from '../assets/img/atras_m.png';


const CargaFotos = ({ cameraStream, fotosCapturadas, setFotosCapturadas, formData }) => {
  const navigate = useNavigate();
  const [currentEtiqueta, setCurrentEtiqueta] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dialog, setDialog] = useState({ open: false, title: '', message: '', error: false });
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const ensuredFormData = formData instanceof InspeccionData ? formData : new InspeccionData(formData);

  useEffect(() => {
    if (!formData || Object.keys(formData).length === 0 || !formData?.tipoVehiculo) {
      console.log('formData o tipoVehiculo no definido, redirigiendo a /form');
      navigate('/form');
    }
  }, [formData, navigate]);

  const fotosRequeridas = () => {
    const fotos = [];
    if (ensuredFormData.es0KM) {
      fotos.push('Certificado de No rodamiento');
    } else if (ensuredFormData.tipoVehiculo === 'Auto') {
      fotos.push('Frente', 'Lateral Derecho', 'Lateral Izquierdo', 'Trasera', 'Frente de Cedula Verde', 'Parabrisas desde Interior', 'Rueda de Auxilio');
      if (ensuredFormData.poseeGNC) fotos.push('Frente de Tarjeta GNC', 'Dorso de Tarjeta GNC');
    } else if (ensuredFormData.tipoVehiculo === 'Moto') {
      fotos.push('Frente_', 'Lateral Derecho_', 'Lateral Izquierdo_', 'Trasera_', 'Frente de Cedula Verde', 'Nro de Chasis');
    }
    return fotos;
  };

  const placeholders = {
    'Frente': Frente,
    'Lateral Derecho': Lateral_Derecho,
    'Lateral Izquierdo': Lateral_Izquierdo,
    'Trasera': Trasera,
    'Frente de Cedula Verde': Frente_de_Cedula_Verde,
    'Parabrisas desde Interior': Parabrisas_desde_Interior,
    'Rueda de Auxilio': Rueda_de_Auxilio,
    'Frente de Tarjeta GNC': Frente_de_Tarjeta_GNC,
    'Dorso de Tarjeta GNC': Dorso_de_Tarjeta_GNC,
    'Nro de Chasis': Nro_de_Chasis,
    'Certificado de No rodamiento': Certificado_de_No_rodamiento,
    'Frente_': Frente_,
    'Lateral Derecho_': Lateral_Derecho_,
    'Lateral Izquierdo_': Lateral_Izquierdo_,
    'Trasera_': Trasera_,
  };

  const indicesFotos = {
    'Frente': 1, 'Lateral Derecho': 2, 'Lateral Izquierdo': 3, 'Trasera': 4,
    'Frente de Cedula Verde': 5, 'Parabrisas desde Interior': 6, 'Rueda de Auxilio': 7,
    'Frente de Tarjeta GNC': 8, 'Dorso de Tarjeta GNC': 9, 'Certificado de No rodamiento': 1,
    'Frente_': 1, 'Lateral Derecho_': 2, 'Lateral Izquierdo_': 3, 'Trasera_': 4, 'Nro de Chasis': 6,
  };

  const handleCapture = async (blob, info) => {
    setVehicleInfo(info);
    setFotosCapturadas((prev) => ({ ...prev, [currentEtiqueta]: blob }));
    setIsLoading(true);
    try {
      const response = await apiService.enviarFotoAlServidor(
        ensuredFormData.toJson(),
        blob,
        currentEtiqueta,
        indicesFotos[currentEtiqueta] || 1
      );
      setDialog({
        open: true,
        title: 'Éxito',
        message: `Foto enviada. Tipo detectado: ${info.tipo}`,
        error: false,
      });
    } catch (error) {
      setDialog({ open: true, title: 'Error', message: `Verifica tu conexión: ${error.message}`, error: true });
    } finally {
      setIsLoading(false);
      setCurrentEtiqueta(null);
    }
  };

  const todasLasFotosCompletadas = () => fotosRequeridas().every((etiqueta) => fotosCapturadas[etiqueta]);

  const handleEnviarTodas = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.enviarDatosAlServidor(ensuredFormData.toJson(), fotosCapturadas);
      if (response.status === 'success') {
        setDialog({
          open: true,
          title: 'Éxito',
          message: response.message || 'Todas las fotos se enviaron correctamente',
          error: false,
          onClose: () => window.location.href = 'https://redas.com.ar',
        });
      } else {
        setDialog({ open: true, title: 'Error', message: response.message || 'Error al enviar', error: true });
      }
    } catch (error) {
      setDialog({ open: true, title: 'Error', message: `Verifica tu conexión: ${error.message}`, error: true });
    } finally {
      setIsLoading(false);
    }
  };

  if (currentEtiqueta) {
    console.log('Pasando cameraStream a CameraScreen:', cameraStream);
    return <CameraScreen cameraStream={cameraStream} onCapture={handleCapture} tipoVehiculo={ensuredFormData.tipoVehiculo} />;
  }

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 4 },
        bgcolor: 'white',
        color: 'black',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {vehicleInfo && (
        <Typography sx={{ mt: 2 }}>
          Tipo detectado: {vehicleInfo.tipo}
        </Typography>
      )}
      <Typography
        variant="h4"
        sx={{
          color: 'black',
          mb: 3,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Carga de Fotos
      </Typography>
      <Button
        variant="outlined"
        onClick={() => navigate('/form')}
        sx={{
          mb: 4,
          borderColor: 'black',
          color: 'black',
          '&:hover': { borderColor: 'red', color: 'red' },
          padding: '8px 16px',
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 'medium',
        }}
      >
        Volver al Formulario
      </Button>
      {isLoading && (
        <CircularProgress
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'red',
            size: 60,
          }}
        />
      )}
      <Grid container spacing={3} justifyContent="center">
        {fotosRequeridas().map((etiqueta) => (
          <Grid item xs={6} sm={4} md={3} key={etiqueta}>
            <Card
              onClick={() => setCurrentEtiqueta(etiqueta)}
              sx={{
                cursor: 'pointer',
                bgcolor: 'white',
                borderRadius: '12px',
                border: '2px solid black',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: 'red',
                  boxShadow: '0 8px 16px rgba(255, 0, 0, 0.2)',
                  transform: 'translateY(-4px)',
                },
                height: '220px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  height: 150,
                  width: '100%',
                  objectFit: 'contain',
                  padding: '0px',
                  backgroundColor: '#f5f5f5',
                }}
                image={fotosCapturadas[etiqueta] ? URL.createObjectURL(fotosCapturadas[etiqueta]) : placeholders[etiqueta]}
                alt={etiqueta}
              />
              <CardContent
                sx={{
                  flexGrow: 1,
                  p: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'white',
                }}
              >
                <Typography
                  sx={{
                    color: 'black',
                    fontSize: '0.9rem',
                    fontWeight: 'medium',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  {etiqueta}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {todasLasFotosCompletadas() && (
        <Button
          variant="contained"
          onClick={handleEnviarTodas}
          sx={{
            mt: 4,
            bgcolor: 'black',
            color: 'white',
            '&:hover': { bgcolor: '#333' },
            padding: '8px 16px',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 'medium',
          }}
        >
          Enviar Todas las Fotos
        </Button>
      )}
      <Dialog open={dialog.open} onClose={() => setDialog({ ...dialog, open: false })}>
        <DialogTitle
          sx={{
            bgcolor: dialog.error ? 'red' : 'black',
            color: 'black',
            fontWeight: 'bold',
            textAlign: 'center',
            py: 1.5,
          }}
        >
          {dialog.title}
        </DialogTitle>
        <DialogContent sx={{ bgcolor: 'white', p: 3 }}>
          <Typography sx={{ color: 'black', textAlign: 'center' }}>{dialog.message}</Typography>
        </DialogContent>
        <DialogActions sx={{ bgcolor: 'white', justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={() => {
              setDialog({ ...dialog, open: false });
              if (dialog.onClose) dialog.onClose();
            }}
            sx={{
              color: 'white',
              bgcolor: 'black',
              '&:hover': { bgcolor: '#333' },
              borderRadius: '8px',
              px: 3,
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CargaFotos;